// extracted by mini-css-extract-plugin
export default {"modules":"styles_modules__CAnwX","container":"styles_container__DO0yi","collapsable":"styles_collapsable__vSUvr"};